import React from 'react'

import { RendererWrapper } from '@app/components/renderers'

import styles from './styles.module.scss'

import type { ColumnSearchToolTitleProps } from './types'

export const ColumnSearchToolTitle: React.FC<ColumnSearchToolTitleProps> = ({ title, children, ...props }) => {
  return (
    <div className={ styles.comlumnSearchToolTitle }>
      { title }

      <RendererWrapper { ...props }>{ children }</RendererWrapper>
    </div>
  )
}
